import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FirstLevelItem from "../components/Sidebar/FirstLevelItem";
import {SERVLET_PATH, VirtualHost} from "../constants";
import {showEarsivInbox, showPredefinedBtn, showProgressPayment, showSidebarSgkFaturalar} from "../helper/permission";

class Faturam24Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "homePage",
            logoVisible: 'block',
            miniLogoVisible: 'none',
        };

        this.hasSidebarMenu = this.hasSidebarMenu.bind(this);
        this.onChangeSelected = this.onChangeSelected.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.onSelectReport = this.onSelectReport.bind(this);
    }

    onChangeSelected(selected, event) {
        this.setState({selected});
        this.props.reload(null, "sidebar");
        this.props.resetMasterSelected();
    }

    onSelectReport(selected, event, type) {
        this.setState({selected});
        this.props.reload(null, "sidebar");
        this.props.onSelectReport(type);
    }

    toggleSidebar() {
        if (this.props.canToggle) {
            document.body.classList.toggle('sidebar-mini');
            this.props.setOffsetWidth(document.getElementById('sidebarModeButton').children[0].offsetWidth);
            this.showLogo();
        }
    }

    showLogo = () => {
        if (document.body.classList.toString().includes('sidebar-mini')) {
            this.setState({
                miniLogoVisible: 'block',
                logoVisible: 'none'
            })
        } else {
            this.setState({
                miniLogoVisible: 'none',
                logoVisible: 'block'
            })
        }
    }

    sidebarHovered = () => {
        if (this.state.miniLogoVisible === 'block') {
            this.setState({
                miniLogoVisible: 'none',
                logoVisible: 'block'
            })
        }
    }

    sidebarHoveredOut = () => {
        this.showLogo();
    }

    isEntegrator() {
        return this.props.currentUser && this.props.currentUser.entegrator;
    }

    isAdminUser() {
        return this.props.currentUser && this.props.currentUser.adminUser;
    }

    isDistributor() {
        return this.props.currentUser && this.props.currentUser.distributor;
    }

    isAccountant() {
        return this.props.currentUser && this.props.currentUser.accountant;
    }

    hasSidebarMenu(title) {
        return this.props.currentUser && (this.props.currentUser.sidebarMenus[title] === true);
    }

    isEsnafFatura() {
        return VirtualHost.conf.resourcePrefix === 'esnaffatura';
    }

    isESMM() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
    }

    isEBelge() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
    }

    isEFatura() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
    }

    isEGiderPusulasi() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EGIDERPUSULASI;
    }

    isEIrsaliye() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EIRSALIYE;
    }

    isEArsiv() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
    }

    isEMM() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EMM;
    }

    isEDefter() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTER;
    }

    isEDefterSaklama() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERSAKLAMA;
    }

    isExchange() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EEXCHANGE;
    }

    isEDefterIkincilKopya() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERIKINCILKOPYA;
    }

    render() {
        const selected = this.props.masterSelected ? this.props.masterSelected : this.state.selected;
        const holder = this.props.currentUser.holder;
        return (
            <div className="sidebar" style={this.props.canToggle ? {} : {pointerEvents: 'none'}}
                 onMouseOver={() => this.sidebarHovered()}
                 onMouseOut={() => this.sidebarHoveredOut()}
            >

                <div className="logo" id="sidebar"
                     style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <a href="/" className="simple-text logo-mini" style={{display: this.state.miniLogoVisible}}>
                        <img className="simple-text logo-mini"
                             src={SERVLET_PATH + "/api/virtual/resource/sidebarMini.png"}
                             style={{padding: '0px 0px 0px 0px'}}/>
                    </a>
                    <img className=" simple-text logo-normal" style={{display: this.state.logoVisible}}
                         src={SERVLET_PATH + "/api/virtual/resource/sidebar.png"}
                    />

                    <div className="navbar-minimize ">
                        <button id='sidebarModeButton' onClick={this.toggleSidebar} style={{marginTop: '10px'}}
                                className=" btn btn-simple btn-icon btn-neutral btn-round">
                            <i className="now-ui-icons text_align-center visible-on-sidebar-regular"/>
                            <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"/>
                        </button>
                    </div>
                </div>

                <div className="sidebar-wrapper scrollbar" id="style-7">
                    {this.props.currentUser && this.props.currentUser.roleId && (this.props.currentUser.roleId !== 5 && this.props.currentUser.roleId !== 3 && this.props.currentUser.roleId !== 4) &&
                    <ul className="nav">
                        <FirstLevelItem name="homePage" label="Ana Sayfa"
                                        isActive={selected === "homePage"}
                                        show={this.hasSidebarMenu("main_homePage")}
                                        icons="fa fa-home fa-fw" clicked={this.onChangeSelected}/>

                        {(this.isEBelge() && !(this.hasSidebarMenu("ednsm_fatura") && this.hasSidebarMenu("ednsm_arsiv") && this.hasSidebarMenu("ednsm_serbestmeslek"))) && this.hasSidebarMenu("create_invoice") &&
                        <FirstLevelItem name="createEditBelge/0" label="Fatura Oluştur"
                                        isActive={selected === "createEditBelge/0"}
                                        show={!this.isAccountant()}
                                        icons="fas fa-shopping-cart"
                                        clicked={this.onChangeSelected}/>
                        }

                        {(this.isEBelge() && !(this.hasSidebarMenu("ednsm_fatura") && this.hasSidebarMenu("ednsm_arsiv") && this.hasSidebarMenu("ednsm_serbestmeslek"))) &&
                        <FirstLevelItem name="belgeTmp" label="Taslak Faturalar"
                                        isActive={selected === "belgeTmp"}
                                        show={!this.isAccountant()}
                                        icons="fa fa-arrow-circle-up"
                                        clicked={this.onChangeSelected}/>
                        }

                        {(this.isEBelge() && !(this.hasSidebarMenu("ednsm_fatura") && this.hasSidebarMenu("ednsm_arsiv") && this.hasSidebarMenu("ednsm_serbestmeslek"))) &&
                        <FirstLevelItem name="belgeSend" label="Giden Faturalar"
                                        isActive={selected === "belgeSend"}
                                        show={!this.isAccountant()}
                                        icons="fa fa-share fa-fw"
                                        clicked={this.onChangeSelected}/>
                        }

                        {this.isEBelge() &&
                        <FirstLevelItem name="belgeIn" label="Gelen Faturalar"
                                        isActive={selected === "belgeIn"}
                                        show={!this.isAccountant()}
                                        icons="fa fa-inbox"
                                        clicked={this.onChangeSelected}/>
                        }

                        {this.isEBelge() &&
                        <FirstLevelItem name="COBelge" label="İptal / İtiraz Talepleri"
                                        isActive={selected === "COBelge"}
                                        show={!this.isAccountant()}
                                        icons="fas fa-ban"
                                        clicked={this.onChangeSelected}/>
                        }

                        {this.isEBelge() &&
                        <FirstLevelItem name="BaBs" label="Ba/Bs"
                                        isActive={selected === "BaBs"}
                                        show={!this.isAccountant()}
                                        icons="fa fa-list"
                                        clicked={this.onChangeSelected}/>
                        }

                        {(this.hasSidebarMenu("ednsm_serbestmeslek") && this.isESMM() && !(this.isEsnafFatura())) &&
                        <li>
                            <a data-toggle="collapse" href="#eArchiveVoucherSMM">
                                <i className="fa fa-clipboard" aria-hidden="true"/>
                                <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}> e-Serbest Meslek<b
                                    className="caret"/></p>
                            </a>
                            <div className="collapse " id="eArchiveVoucherSMM">
                                <ul className="nav">
                                    {this.hasSidebarMenu("ednsm_smm_eVoucherST") &&
                                    <li className={selected === "eVoucherST" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("eVoucherST", e)}>
                                        <Link to="/eVoucherST">
                                            <i className="fa fa-arrow-circle-up"/>
                                            <span className="sidebar-normal"> Taslak Makbuzlar</span>
                                        </Link>
                                    </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_smm_eVoucherS") &&
                                    <li className={selected === "eVoucherS" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("eVoucherS", e)}>
                                        <Link to="/eVoucherS">
                                            <i className="fa fa-clipboard"/>
                                            <span
                                                style={{letterSpacing:'0.4px'}}
                                                className="sidebar-normal"> e-Serbest Meslek Makbuzlar</span>
                                        </Link>
                                    </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_smm_eVoucherTransfer") &&
                                        <li className={selected === "eVoucherSTransfer" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("eVoucherSTransfer", e)}>
                                            <Link to="/eVoucherSTransfer">
                                                <i className="fa fa-reply"/>
                                                <span
                                                    className="sidebar-normal">Transfer Makbuzlar</span>
                                            </Link>
                                        </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_smm_eArchiveReportRequest") &&
                                    <li className={selected === "eSMMReportRequest" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("eSMMReportRequest", e)}>
                                        <Link to="/eArchiveReportRequest/voucher">
                                            <i className="fa fa-send"/>
                                            <span className="sidebar-normal">Rapor Gönderme Talebi</span>
                                        </Link>
                                    </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_smm_sentReportsList") &&
                                    <li className={selected === "eSMMSentReportsList" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onSelectReport("eSMMSentReportsList", e, "serbestMeslek")}>
                                        <Link to="/sentReportsList/voucher">
                                            <i className="fa fa-area-chart"/>
                                            <span className="sidebar-normal">Gönderilmiş Raporlar</span>
                                        </Link>
                                    </li>
                                    }
                                </ul>
                            </div>
                        </li>
                        }

                        {(this.hasSidebarMenu("main_edonusum") && this.isEsnafFatura() &&
                            (this.isEFatura() ||
                             this.isEArsiv() ||
                             this.isEIrsaliye() ||
                             this.isEMM() ||
                             this.isESMM() ||
                             this.isEDefter() ||
                             this.isEDefterIkincilKopya() ||
                             this.isEDefterSaklama() ||
                             this.isEGiderPusulasi() ||
                             this.isExchange()
                            )) &&
                        <li>
                            <a data-toggle="collapse" href="#pagesTransformation">
                                <i className="fa fa-recycle"/>
                                <p>e-Dönüşüm<b className="caret"/></p>
                            </a>
                            <div className="collapse " id="pagesTransformation">
                                <ul className="nav">
                                    {this.hasSidebarMenu("ednsm_fat_invoiceTmp") && this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") && this.hasSidebarMenu("create_invoice") &&
                                        <li className={selected === "invoiceCreate" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("invoiceCreate", e)}>
                                            <Link to={(showPredefinedBtn()) ?
                                                "/createEditInvoice/Tmp/0/EFATURA"
                                                :
                                                "/invoice/create"}>
                                                <i className="fa fa-arrow-circle-up"/>
                                                <span className="sidebar-normal">{"Fatura Oluştur"}</span>
                                            </Link>
                                        </li>
                                    }

                                    {(this.isEFatura() || this.isEIrsaliye()) && this.hasSidebarMenu("ednsm_queryEnvelope") &&
                                        <li style={{"paddingLeft": "10px"}}>
                                            <a onClick={this.props.queryEnvelopeListener}>
                                                <i className="fa fa-search"/>
                                                <span className="sidebar-normal">{"Zarf Sorgulama"}</span>
                                            </a>
                                        </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_irsaliye") && this.isEIrsaliye()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eDespatch">
                                            <i className="fa fa-file-text fa-fw"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className=""> e-İrsaliye<b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eDespatch">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_irs_despatch") &&
                                                <li className={selected === "despatch" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("despatch", e)}>
                                                    <Link to="/despatch">
                                                        <i className="fa fa-arrow-circle-up"/>
                                                        <span className="sidebar-normal">Taslak İrsaliyeler </span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_irs_eDespatchOutbox") &&
                                                <li className={selected === "eDespatchOutbox" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eDespatchOutbox", e)}>
                                                    <Link to="/eDespatchOutbox">
                                                        <i className="fa fa-share fa-fw"/>
                                                        <span className="sidebar-normal">Giden İrsaliyeler</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_irs_eDespatchInbox") &&
                                                <li className={selected === "eDespatchInbox" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eDespatchInbox", e)}>
                                                    <Link to="/eDespatchInbox">
                                                        <i className="fa fa-inbox"/>
                                                        <span className="sidebar-normal">Gelen İrsaliyeler</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_irs_gibusers") &&
                                                    <li className={selected === "gibusersD" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("gibusersD", e)}>
                                                        <Link to="/gibusersD">
                                                            <i className="fa fa-users" aria-hidden="true"/>
                                                            <span className="sidebar-normal">GİB Kayıtlı Kullanıcılar</span>
                                                        </Link>
                                                    </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_irs_eDespatchOutboxTransfer") &&
                                                <li className={selected === "eDespatchOutboxTransfer" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eDespatchOutboxTransfer", e)}>
                                                    <Link to="/eDespatchOutboxTransfer">
                                                        <i className="fa fa-share"/>
                                                        <span
                                                            className="sidebar-normal">Giden Transfer İrsaliyeler</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_irs_eDespatchInboxTransfer") &&
                                                <li className={selected === "eDespatchInboxTransfer" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eDespatchInboxTransfer", e)}>
                                                    <Link to="/eDespatchInboxTransfer">
                                                        <i className="fa fa-reply"/>
                                                        <span
                                                            className="sidebar-normal">Gelen Transfer İrsaliyeler</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_fatura") && this.isEFatura() ) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eInvoice">
                                            <i className="fa fa-newspaper-o"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className=""> e-Fatura<b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eInvoice">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_fat_invoiceTmp") &&
                                                <li className={selected === "invoiceTmp" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("invoiceTmp", e)}>
                                                    <Link to="/invoiceTmp">
                                                        <i className="fa fa-arrow-circle-up"/>
                                                        <span className="sidebar-normal"> Taslak Faturalar </span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_fat_eInvoiceOutbox") &&
                                                <li className={selected === "eInvoiceOutbox" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eInvoiceOutbox", e)}>
                                                    <Link to="/eInvoiceOutbox">
                                                        <i className="fa fa-share fa-fw"/>
                                                        <span className="sidebar-normal">Giden Faturalar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_fat_eInvoiceInbox") &&
                                                <li className={selected === "eInvoiceInbox" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eInvoiceInbox", e)}>
                                                    <Link to="/eInvoiceInbox">
                                                        <i className="fa fa-inbox"/>
                                                        <span className="sidebar-normal">Gelen Faturalar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_fat_gibusers") &&
                                                <li className={selected === "gibusersI" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("gibusersI", e)}>
                                                    <Link to="/gibusersI">
                                                        <i className="fa fa-users" aria-hidden="true"/>
                                                        <span className="sidebar-normal">GİB Kayıtlı Kullanıcılar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_fat_sgkFaturalar") && showSidebarSgkFaturalar() && this.hasSidebarMenu("ednsm_fat_hospitalInvoice") &&
                                                <li className={selected === "sgkFaturalar" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("sgkFaturalar", e)}>
                                                    <Link to="/sgkFaturalar">
                                                        <i className="fa fa-hospital-o" aria-hidden="true"/>
                                                        <span className="sidebar-normal">Hastane Fatura</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_fat_eInvoiceOutboxTransfer") &&
                                                <li className={selected === "eInvoiceOutboxTransfer" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eInvoiceOutboxTransfer", e)}>
                                                    <Link to="/eInvoiceOutboxTransfer">
                                                        <i className="fa fa-share"/>
                                                        <span className="sidebar-normal">Giden Transfer Faturalar</span>
                                                    </Link>
                                                </li>
                                                }

                                                {this.hasSidebarMenu("ednsm_fat_eInvoiceInboxTransfer") &&
                                                <li className={selected === "eInvoiceInboxTransfer" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eInvoiceInboxTransfer", e)}>
                                                    <Link to="/eInvoiceInboxTransfer">
                                                        <i className="fa fa-reply"/>
                                                        <span className="sidebar-normal">Gelen Transfer Faturalar</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_arsiv") && this.isEArsiv()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eArchiveInvoice">
                                            <i className="fa fa-archive"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className=""> e-Arşiv<b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eArchiveInvoice">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") &&
                                                <li className={selected === "archiveInvoiceTmp" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("archiveInvoiceTmp", e)}>
                                                    <Link to="/archiveInvoiceTmp">
                                                        <i className="fa fa-arrow-circle-up"/>
                                                        <span className="sidebar-normal"> Taslak Arşiv Faturalar </span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_ars_eAInvoice") &&
                                                <li className={selected === "eAInvoice" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eAInvoice", e)}>
                                                    <Link to="/eAInvoice">
                                                        <i className="fa fa-archive"/>
                                                        <span className="sidebar-normal">e-Arşiv Faturalar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {(this.hasSidebarMenu("ednsm_ars_eAInvoice") && this.props.entegratorConf && showEarsivInbox(this.props.entegratorConf.identifier)) && this.hasSidebarMenu("ednsm_ars_eAInvoiceInbox") &&
                                                    <li className={selected === "belgeIn" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("belgeIn", e)}>
                                                        <Link to="/belgeIn">
                                                            <i className="fa fa-inbox"/>
                                                            <span className="sidebar-normal">Gelen e-Arşiv Faturalar</span>
                                                        </Link>
                                                    </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_ars_eAInvoiceTransfer") &&
                                                <li className={selected === "eAInvoiceTransfer" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eAInvoiceTransfer", e)}>
                                                    <Link to="/eAInvoiceTransfer">
                                                        <i className="fa fa-reply"/>
                                                        <span className="sidebar-normal">e-Arşiv Transfer Faturalar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_ars_eArchiveReportRequest") &&
                                                <li className={selected === "eArchiveReportRequest" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eArchiveReportRequest", e)}>
                                                    <Link to="/eArchiveReportRequest/archive">
                                                        <i className="fa fa-send"/>
                                                        <span className="sidebar-normal">Rapor Gönderme Talebi</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_ars_sentReportsList") &&
                                                <li className={selected === "eArchiveSentReportsList" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onSelectReport("eArchiveSentReportsList", e, "eArchive")}>
                                                    <Link to="/sentReportsList/archive">
                                                        <i className="fa fa-area-chart"/>
                                                        <span className="sidebar-normal">Gönderilmiş Raporlar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {false && this.hasSidebarMenu("ednsm_ars_mReportList") &&
                                                <li style={{"paddingLeft": "5px"}}>
                                                    <a data-toggle="collapse" href="#okcReport">
                                                        <i className="fa fa-archive"/>
                                                        <p className="">ÖKC Mali Raporları<b className="caret"/></p>
                                                    </a>
                                                    <div className="collapse " id="okcReport">
                                                        <ul className="nav">
                                                            {this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") &&
                                                            <li className={selected === "okcReportList" ? 'active' : ''}
                                                                style={{"paddingLeft": "10px"}}
                                                                onClick={(e) => this.onChangeSelected("okcReportList", e)}>
                                                                <Link to="/okcReportList">
                                                                    <i className="fa fa-arrow-circle-up"/>
                                                                    <span
                                                                        className="sidebar-normal">Taslak Raporlar</span>
                                                                </Link>
                                                            </li>
                                                            }
                                                            {this.hasSidebarMenu("ednsm_ars_archiveInvoiceTmp") &&
                                                            <li className={selected === "okcReports" ? 'active' : ''}
                                                                style={{"paddingLeft": "10px"}}
                                                                onClick={(e) => this.onChangeSelected("okcReports", e)}>
                                                                <Link to="/okcReports">
                                                                    <i className="fa fa-share fa-fw"/>
                                                                    <span
                                                                        className="sidebar-normal">Giden Raporlar</span>
                                                                </Link>
                                                            </li>
                                                            }
                                                            {this.hasSidebarMenu("ednsm_ars_expenseNoteList") &&
                                                            <li className={selected === "expenseNoteList" ? 'active' : ''}
                                                                style={{"paddingLeft": "10px"}}
                                                                onClick={(e) => this.onChangeSelected("expenseNoteList", e)}>
                                                                <Link to="/expenseNoteList">
                                                                    <i className="fa fa-share-square"/>
                                                                    <span
                                                                        className="sidebar-normal">Gider Pusulaları</span>
                                                                </Link>
                                                            </li>
                                                            }
                                                        </ul>
                                                    </div>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_mustahsil") && this.isEMM()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eArchiveVoucherMM">
                                            <i className="fa fa-microchip"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className=""> e-Müstahsil<b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eArchiveVoucherMM">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_mm_eVoucherMT") &&
                                                <li className={selected === "eVoucherMT" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eVoucherMT", e)}>
                                                    <Link to="/eVoucherMT">
                                                        <i className="fa fa-arrow-circle-up"/>
                                                        <span className="sidebar-normal"> Taslak Makbuzlar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_mm_eVoucherM") &&
                                                <li className={selected === "eVoucherM" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eVoucherM", e)}>
                                                    <Link to="/eVoucherM">
                                                        <i className="fa fa-list-alt"/>
                                                        <span className="sidebar-normal"> e-Müstahsil Makbuzlar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_mm_eVoucherTransfer") &&
                                                    <li className={selected === "eVoucherMTransfer" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("eVoucherMTransfer", e)}>
                                                        <Link to="/eVoucherMTransfer">
                                                            <i className="fa fa-reply"/>
                                                            <span
                                                                className="sidebar-normal">Transfer Makbuzlar</span>
                                                        </Link>
                                                    </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_mm_eArchiveReportRequest") &&
                                                <li className={selected === "eMMReportRequest" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eMMReportRequest", e)}>
                                                    <Link to="/eArchiveReportRequest/voucher">
                                                        <i className="fa fa-send"/>
                                                        <span className="sidebar-normal">Rapor Gönderme Talebi</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_mm_sentReportsList") &&
                                                <li className={selected === "eMMSentReportsList" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onSelectReport("eMMSentReportsList", e, "eArchive")}>
                                                    <Link to="/sentReportsList/voucher">
                                                        <i className="fa fa-area-chart"/>
                                                        <span className="sidebar-normal">Gönderilmiş Raporlar</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_serbestmeslek") && this.isESMM()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eArchiveVoucherSMM">
                                            <i className="fa fa-clipboard" aria-hidden="true"/>
                                            <p style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}> e-Serbest Meslek<b
                                                className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eArchiveVoucherSMM">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_smm_eVoucherST") &&
                                                <li className={selected === "eVoucherST" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eVoucherST", e)}>
                                                    <Link to="/eVoucherST">
                                                        <i className="fa fa-arrow-circle-up"/>
                                                        <span className="sidebar-normal"> Taslak Makbuzlar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_smm_eVoucherS") &&
                                                <li className={selected === "eVoucherS" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eVoucherS", e)}>
                                                    <Link to="/eVoucherS">
                                                        <i className="fa fa-clipboard"/>
                                                        <span
                                                            style={{letterSpacing: '0.4px'}}
                                                            className="sidebar-normal"> e-Serbest Meslek Makbuzlar</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_smm_eVoucherTransfer") &&
                                                    <li className={selected === "eVoucherSTransfer" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("eVoucherSTransfer", e)}>
                                                        <Link to="/eVoucherSTransfer">
                                                            <i className="fa fa-reply"/>
                                                            <span
                                                                className="sidebar-normal">Transfer Makbuzlar</span>
                                                        </Link>
                                                    </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_smm_eArchiveReportRequest") &&
                                                <li className={selected === "eSMMReportRequest" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eSMMReportRequest", e)}>
                                                    <Link to="/eArchiveReportRequest/voucher">
                                                        <i className="fa fa-send"/>
                                                        <span className="sidebar-normal">Rapor Gönderme Talebi</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_smm_sentReportsList") &&
                                                <li className={selected === "eSMMSentReportsList" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onSelectReport("eSMMSentReportsList", e, "serbestMeslek")}>
                                                    <Link to="/sentReportsList/voucher">
                                                        <i className="fa fa-area-chart"/>
                                                        <span className="sidebar-normal">Gönderilmiş Raporlar</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_defter") && this.isEDefter()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#edefter">
                                            <i className="fa fa-book" aria-hidden="true"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className="sidebar-normal"> E-Defter<b className="caret"/></p>
                                        </a>
                                        <div className="collapse" id="edefter">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_def_edefterCreate") &&
                                                <li className={selected === "edefterCreate" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("edefterCreate", e)}>
                                                    <Link to="/edefter/create">
                                                        <i className="fa fa-upload"/>
                                                        <span className="sidebar-normal">E-Defter Oluştur</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_def_edefterList") &&
                                                <li className={selected === "edefterList" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("edefterList", e)}>
                                                    <Link to="/edefter/list">
                                                        <i className="fa fa-list"/>
                                                        <span className="sidebar-normal">Oluşturulan E-Defterler</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_def_edefterCustomerDefterInformation") &&
                                                <li className={selected === "edefterCustomerDefterInformation" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("edefterCustomerDefterInformation", e)}>
                                                    <Link to="/edefter/eDefterInformation">
                                                        <i className="fa fa-align-left"/>
                                                        <span className="sidebar-normal">E-Defter Bilgileri</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {(this.hasSidebarMenu("ednsm_deftersaklama") && this.isEDefterSaklama()) &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#edefterStorage">
                                            <i className="fa fa-book" aria-hidden="true"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className="sidebar-normal"> E-Defter Saklama
                                                <b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="edefterStorage">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_defsak_uploadDefter") &&
                                                <li className={selected === "uploadDefter" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("uploadDefter", e)}>
                                                    <Link to="/edefterZipYukleme">
                                                        <i className="fa fa-file-archive"/>
                                                        <span className="sidebar-normal">E-Defter Zip Yükleme</span>
                                                    </Link>
                                                </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_defsak_uploadedDefter") &&
                                                <li className={selected === "uploadedDefter" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("uploadedDefter", e)}>
                                                    <Link to="/yuklenenDefterler">
                                                        <i className="fa fa-list"/>
                                                        <span className="sidebar-normal">Yüklenen Defterler</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }
                                    {this.isEDefterIkincilKopya() && this.hasSidebarMenu("ednsm_def_edefterSecondaryCopy") &&
                                        <li className={selected === "secondaryCopyTransfer" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("secondaryCopyTransfer", e)}>
                                            <Link to="/secondaryCopyTransfer">
                                                <i className="fa fa-book"/>
                                                <span className="sidebar-normal">E-Defter İkincil Kopya</span>
                                            </Link>
                                        </li>
                                    }

                                    {(this.isEGiderPusulasi()) && this.hasSidebarMenu("ednsm_egider") &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eexpenseNote">
                                            <i className="fa fa-book" aria-hidden="true"/>
                                            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                               className="sidebar-normal"> e-Gider Pusulası
                                                <b className="caret"/></p>
                                        </a>
                                        <div className="collapse " id="eexpenseNote">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_egdr_eGiderPusulalar") &&
                                                <li className={selected === "newExpenseNote" ? 'active' : ''}
                                                    style={{"paddingLeft": "5px"}}
                                                    onClick={(e) => this.onChangeSelected("eExpenseNotes", e)}>
                                                    <Link to="/newExpenseNote">
                                                        <i className="fa fa-list"/>
                                                        <span className="sidebar-normal">E-Gider Pusulalar</span>
                                                    </Link>
                                                </li>
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                    }

                                    {this.isExchange() && this.hasSidebarMenu("ednsm_edoviz") &&
                                    <li style={{"paddingLeft": "10px"}}>
                                        <a data-toggle="collapse" href="#eArchiveVoucherEX">
                                            <i className="fa fa-eur" aria-hidden="true"/>
                                            <span className="sidebar-normal"> e-Döviz<b
                                                className="caret"/></span>
                                        </a>
                                        <div className="collapse " id="eArchiveVoucherEX">
                                            <ul className="nav">
                                                {this.hasSidebarMenu("ednsm_edoviz_taslakdoviz") &&
                                                    <li className={selected === "eVoucherET" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("eVoucherET", e)}>
                                                        <Link to="/eVoucherET">
                                                            <i className="fa fa-arrow-circle-up"/>
                                                            <span className="sidebar-normal"> Taslak Dövizler</span>
                                                        </Link>
                                                    </li>
                                                }
                                                {this.hasSidebarMenu("ednsm_edoviz_makbuzlar") &&
                                                    <li className={selected === "exchangeList" ? 'active' : ''}
                                                        style={{"paddingLeft": "5px"}}
                                                        onClick={(e) => this.onChangeSelected("exchangeList", e)}>
                                                        <Link to="/exchangeList">
                                                            <i className="fa fa-clipboard"/>
                                                            <span
                                                                className="sidebar-normal"> e-Döviz Makbuzlar</span>
                                                        </Link>
                                                    </li>
                                                }

                                            </ul>
                                        </div>
                                    </li>
                                    }
                                </ul>
                            </div>
                        </li>
                        }

                        <FirstLevelItem name="stockCard" label="Stok Yönetimi"
                                        isActive={selected === "stockCard"}
                                        show={this.hasSidebarMenu("main_stockCard")}
                                        icons="fas fa-shopping-cart"
                                        clicked={this.onChangeSelected}/>


                        <FirstLevelItem name="externalCustomer" label="Cari"
                                        show={this.hasSidebarMenu("ednsm_cari")}
                                        isActive={selected === "externalCustomer"} icons="fas fa-user-tie"
                                        clicked={() => this.onChangeSelected('externalCustomer')}/>

                        {(this.isEFatura() || this.isEIrsaliye() || this.isEArsiv() || this.isESMM() || this.isEMM() || this.isEBelge()) && this.hasSidebarMenu("ednsm_raporlar") &&
                        <li>
                            <a data-toggle="collapse" href="#excelReports">
                                <i className="fa fa-files-o" aria-hidden="true"/>
                                <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>Raporlar<b
                                    className="caret"/></p>
                            </a>
                            <div className="collapse" id="excelReports">
                                <ul className="nav">
                                    {this.hasSidebarMenu("ednsm_rapor_customize") &&
                                        <li style={{"paddingLeft": "10px"}}
                                            className={selected === "customizeExcel" ? 'active' : ''}
                                            onClick={(e) => this.onChangeSelected("customizeExcel", e)}>
                                            <Link to="/customizeExcel">
                                                <i className="fa fa-files-o"/>
                                                <span className="sidebar-normal">Rapor Özelleştir</span>
                                            </Link>
                                        </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_rapor_generalReports") &&
                                        <li style={{"paddingLeft": "10px"}}
                                            className={selected === "excelRequest" ? 'active' : ''}
                                            onClick={(e) => this.onChangeSelected("excelRequest", e, "excelRequest")}>
                                            <Link to="/excelRequest">
                                                <i className="fa fa-files-o"/>
                                                <span className="sidebar-normal">Genel Raporlar</span>
                                            </Link>
                                        </li>
                                    }
                                    {this.hasSidebarMenu("ednsm_rapor_rowReports") &&
                                        <li style={{"paddingLeft": "10px"}}
                                            className={selected === "excelRequestWithLine" ? 'active' : ''}
                                            onClick={(e) => this.onChangeSelected("excelRequestWithLine", e, "excelRequestWithLine")}>
                                            <Link to="/excelRequestWithLine">
                                                <i className="fa fa-files-o"/>
                                                <span className="sidebar-normal">Satır Raporları</span>
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </li>
                        }

                        {this.hasSidebarMenu("main_settings") &&
                        <li>
                            <a data-toggle="collapse" href="#customerSettings">
                                <i className="fas fa-tools"/>
                                <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>Ayarlar<b
                                    className="caret"/></p>
                            </a>
                            <div className="collapse " id="customerSettings">
                                <ul className="nav">
                                    {(this.hasSidebarMenu("settings_companyProfile") && this.isAdminUser()) &&
                                    <li className={selected === "companyProfile" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("companyProfile", e)}>
                                        <Link to={"/companyProfile/" + this.props.currentUser.customerId}>
                                            <i className="fa fa-address-card" aria-hidden="true"/>
                                            <span className="sidebar-normal"> Firma Profili </span>
                                        </Link>
                                    </li>}

                                    {this.hasSidebarMenu("settings_xsltYonetimi") &&
                                    <li className={selected === "xsltYonetimi" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("xsltYonetimi", e)}>
                                        <Link to="/xsltYonetimi">
                                            <i className="fa fa-random" aria-hidden="true"/>
                                            <span className="sidebar-normal"> Fatura Tasarımı </span>
                                        </Link>
                                    </li>}

                                    {(this.hasSidebarMenu("settings_userList") && this.isAdminUser()) &&
                                    <li className={selected === "userList" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("userList", e)}>
                                        <Link to="/userList">
                                            <i className="fa fa-users" aria-hidden="true"/>
                                            <span className="sidebar-normal"> Kullanıcı İşlemleri </span>
                                        </Link>
                                    </li>}

                                    {(this.hasSidebarMenu("settings_prefixCode") && this.isAdminUser() &&
                                            (this.isESMM() || this.isEArsiv() || this.isEFatura() ||
                                                this.isEIrsaliye() || this.isEMM() || this.isExchange() || this.isEGiderPusulasi())) &&
                                    <li className={selected === "prefixCode" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("prefixCode", e)}>
                                        <Link to="/prefixCode">
                                            <i className="fa fa-file-text"/>
                                            <span className="sidebar-normal">Belge Ön Eki</span>
                                        </Link>
                                    </li>}

                                    {(this.isAdminUser() && (this.isEArsiv() || this.isEFatura())) && this.hasSidebarMenu("vkn_tckn_kisitlari") &&
                                        <li className={selected === "hiddenVknTcknList" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("hiddenVknTcknList", e)}>
                                            <Link to="/hiddenVknTcknList">
                                                <i className="fa fa-file-text"/>
                                                <span className="sidebar-normal">VKN/TCKN Kısıtları</span>
                                            </Link>
                                        </li>
                                    }

                                    {this.hasSidebarMenu("settings_inboxWarning") &&
                                        <li className={selected === "inboxWarning" ? 'active' : ''}
                                            style={{"paddingLeft": "10px"}}
                                            onClick={(e) => this.onChangeSelected("inboxWarning", e)}>
                                            <Link to="/inboxWarning">
                                                <i className="fa fa-exclamation-circle" aria-hidden="true"/>
                                                <span className="sidebar-normal"> Fatura Uyarı Bilgileri </span>
                                            </Link>
                                        </li>}

                                    {(this.isEMM() || this.isEFatura() || this.isEArsiv() || this.isEIrsaliye()) &&  this.hasSidebarMenu("marking") &&
                                        <li className={selected === "tagList" ? 'active' : ''}
                                            style={{"paddingLeft": "5px"}}
                                            onClick={(e) => this.onChangeSelected("tagList", e)}>
                                            <Link to="/tagList">
                                                <i className="fa fa-flag"/>
                                                <span className="sidebar-normal">İşaretler</span>
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </li>
                        }

                        {(((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) || this.props.currentUser.accountant) && this.hasSidebarMenu("portal_managament") &&
                        <li>
                            <a data-toggle="collapse" href="#manage">
                                <i className="fa fa-cogs"/>
                                <p>Portal Yönetimi<b className="caret"/></p>
                            </a>
                            <div className="collapse " id="manage">
                                <ul className="nav">
                                    {!this.isDistributor() && this.hasSidebarMenu("customer_actions") &&
                                    <li className={selected === "customer" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("customer", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/customer">
                                            <i className="fa fa-address-card"/>
                                            <span className="sidebar-normal">Müşteri İşlemleri</span>
                                        </Link>
                                    </li>
                                    }

                                    {!this.isDistributor() && !this.props.currentUser.accountant && this.hasSidebarMenu("all_users") &&
                                    <li className={selected === "cUserList" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("cUserList", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/cUserList">
                                            <i className="fa fa-users"/>
                                            <span className="sidebar-normal">Tüm Kullanıcılar</span>
                                        </Link>
                                    </li>}

                                    {!this.isDistributor() && !this.props.currentUser.accountant && this.hasSidebarMenu("document_status") &&
                                    <li className={selected === "documentStatusInfo" ? 'active' : ''}
                                        style={{"paddingLeft": "10px"}}
                                        onClick={(e) => this.onChangeSelected("documentStatusInfo", e)}>
                                        <Link to="/documentStatusInfo">
                                            <i className="fa fa-share"/>
                                            <span className="sidebar-normal">Belge Durumu</span>
                                        </Link>
                                    </li>
                                    }


                                    {!this.isDistributor() && !this.props.currentUser.accountant && this.hasSidebarMenu("credit_pool") &&
                                    <li className={selected === "creditPoolList" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("creditPoolList", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/creditPoolList">
                                            <i className="fa fa-server"/>
                                            <span className="sidebar-normal">Kredi Havuzu</span>
                                        </Link>
                                    </li>}

                                    {((this.isEntegrator() || this.isDistributor()) && this.isAdminUser() && showProgressPayment(this.props.currentUser.customerId)) && this.hasSidebarMenu("ednsm_settings_progressPayment") &&
                                    <li className={selected === "progresspayment" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("progresspayment", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/progresspayment">
                                            <i className="fa fa-address-card"/>
                                            <span className="sidebar-normal">Hakediş</span>
                                        </Link>
                                    </li>
                                    }

                                    {!this.props.currentUser.accountant && this.hasSidebarMenu("credit_report") &&
                                    <li className={selected === "creditList" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("creditList", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/creditList">
                                            <i className="fa fa-server"/>
                                            <span className="sidebar-normal">Kredi Raporu</span>
                                        </Link>
                                    </li>}

                                    {!this.isDistributor() && !this.props.currentUser.accountant && this.hasSidebarMenu("request_report") &&
                                    <li className={selected === "requestMessageList" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("requestMessageList", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/requestMessageList">
                                            <i className="fa fa-server"/>
                                            <span className="sidebar-normal">İstek/Talep Raporu</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </div>
                        </li>
                        }
                    </ul>}

                    {this.props.currentUser && this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4) && this.hasSidebarMenu("portal_managament") &&
                    <ul className="nav">
                        <li>
                            <a data-toggle="collapse" href="#manage">
                                <i className="fa fa-cogs"/>
                                <p>Portal Yönetimi<b className="caret"/></p>
                            </a>
                            <div className="collapse " id="manage">
                                <ul className="nav">
                                    {this.hasSidebarMenu("customer_actions") &&
                                    <li className={selected === "customer" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("customer", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/customer">
                                            <i className="fa fa-address-card"/>
                                            <span className="sidebar-normal">Müşteri İşlemleri</span>
                                        </Link>
                                    </li>
                                    }
                                    {this.hasSidebarMenu("all_users") &&
                                    <li className={selected === "cUserList" ? 'active' : ''}
                                        onClick={(e) => this.onChangeSelected("cUserList", e)}
                                        style={{"paddingLeft": "10px"}}>
                                        <Link to="/cUserList">
                                            <i className="fa fa-users"/>
                                            <span className="sidebar-normal">Tüm Kullanıcılar</span>
                                        </Link>
                                    </li>
                                    }
                                </ul>
                            </div>
                        </li>
                    </ul>}
                </div>
            </div>
        );
    }
}

export default Faturam24Sidebar;